import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";
import {
  FaUser,
  FaEnvelope,
  FaBuilding,
  FaIdCard,
  FaClock,
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import moment from "moment";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

function Welcome() {
  const user = useSelector((state) => state.auth.user);
  const currentTime = moment().format("MMMM Do YYYY, h:mm A");

  return (
    <DashboardLayout>
      <MDBox py={3}>
        {/* Welcome Section */}
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={10}>
            {/* Main Welcome Card */}
            <MDBox
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "16px",
                padding: "40px",
                boxShadow: "0 10px 40px rgba(102, 126, 234, 0.3)",
                color: "white",
                marginBottom: "30px",
              }}
            >
              <Grid container spacing={3} alignItems="center">
                {/* Logo Section */}
                <Grid item xs={12} md={3} sx={{ textAlign: "center" }}>
                  <MDBox
                    sx={{
                      width: "150px",
                      height: "150px",
                      margin: "0 auto",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                      padding: "20px",
                    }}
                  >
                    <img
                      src={require("../../assets/images/pngwing.com.png")}
                      alt="Katsina State Logo"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </MDBox>
                </Grid>

                {/* Welcome Text Section */}
                <Grid item xs={12} md={9}>
                  <MDTypography
                    variant="h2"
                    sx={{
                      color: "white",
                      fontWeight: "bold",
                      marginBottom: "10px",
                      fontSize: { xs: "1.8rem", md: "2.5rem" },
                    }}
                  >
                    Welcome Back, {user?.username || "User"}!
                  </MDTypography>
                  <MDTypography
                    variant="h5"
                    sx={{
                      color: "rgba(255,255,255,0.9)",
                      marginBottom: "15px",
                      fontSize: { xs: "1rem", md: "1.3rem" },
                    }}
                  >
                    Katsina State E-Budget System (KTEB)
                  </MDTypography>
                  <MDTypography
                    variant="body1"
                    sx={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: { xs: "0.9rem", md: "1rem" },
                    }}
                  >
                    Ministry of Budget & Economic Planning
                  </MDTypography>
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "15px",
                      color: "rgba(255,255,255,0.7)",
                      fontSize: "0.9rem",
                    }}
                  >
                    <FaClock style={{ marginRight: "8px" }} />
                    {currentTime}
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>

            {/* User Information Cards */}
            <Grid container spacing={3}>
              {/* User Profile Card */}
              <Grid item xs={12} md={6}>
                <MDBox
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "12px",
                    padding: "30px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    height: "100%",
                  }}
                >
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <MDBox
                      sx={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "12px",
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "15px",
                      }}
                    >
                      <FaUser style={{ color: "white", fontSize: "24px" }} />
                    </MDBox>
                    <MDTypography
                      variant="h5"
                      sx={{ fontWeight: "600", color: "#344767" }}
                    >
                      User Profile
                    </MDTypography>
                  </MDBox>

                  <MDBox sx={{ marginTop: "20px" }}>
                    <InfoRow
                      icon={<FaUser />}
                      label="Username"
                      value={user?.username || "N/A"}
                    />
                    <InfoRow
                      icon={<FaEnvelope />}
                      label="Email"
                      value={user?.email || "N/A"}
                    />
                    <InfoRow
                      icon={<FaIdCard />}
                      label="User ID"
                      value={user?.id || "N/A"}
                    />
                    <InfoRow
                      icon={<FaBuilding />}
                      label="Role"
                      value={user?.role || "N/A"}
                    />
                  </MDBox>
                </MDBox>
              </Grid>

              {/* MDA Information Card */}
              <Grid item xs={12} md={6}>
                <MDBox
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "12px",
                    padding: "30px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    height: "100%",
                  }}
                >
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <MDBox
                      sx={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "12px",
                        background:
                          "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "15px",
                      }}
                    >
                      <FaBuilding
                        style={{ color: "white", fontSize: "24px" }}
                      />
                    </MDBox>
                    <MDTypography
                      variant="h5"
                      sx={{ fontWeight: "600", color: "#344767" }}
                    >
                      MDA Information
                    </MDTypography>
                  </MDBox>

                  <MDBox sx={{ marginTop: "20px" }}>
                    <InfoRow
                      icon={<FaBuilding />}
                      label="MDA Name"
                      value={user?.mda || "N/A"}
                    />
                    <InfoRow
                      icon={<FaIdCard />}
                      label="MDA Code"
                      value={user?.mda_code || "N/A"}
                    />
                    <InfoRow
                      icon={<MdDashboard />}
                      label="Department"
                      value={user?.department || "N/A"}
                    />
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid>

            {/* Quick Stats or Additional Info */}
            <MDBox
              sx={{
                marginTop: "30px",
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "30px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <MDTypography
                variant="h5"
                sx={{
                  fontWeight: "600",
                  color: "#344767",
                  marginBottom: "20px",
                }}
              >
                System Information
              </MDTypography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                  <StatCard
                    title="Application"
                    value="KTEB"
                    color="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <StatCard
                    title="Version"
                    value="2.0"
                    color="linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <StatCard
                    title="Status"
                    value="Active"
                    color="linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <StatCard
                    title="Session"
                    value="Logged In"
                    color="linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
                  />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

// Helper component for info rows
const InfoRow = ({ icon, label, value }) => (
  <MDBox
    sx={{
      display: "flex",
      alignItems: "center",
      padding: "12px 0",
      borderBottom: "1px solid #f0f2f5",
      "&:last-child": {
        borderBottom: "none",
      },
    }}
  >
    <MDBox
      sx={{
        color: "#667eea",
        fontSize: "18px",
        marginRight: "15px",
        minWidth: "20px",
      }}
    >
      {icon}
    </MDBox>
    <MDBox sx={{ flex: 1 }}>
      <MDTypography
        variant="caption"
        sx={{ color: "#7b809a", fontSize: "0.75rem" }}
      >
        {label}
      </MDTypography>
      <MDTypography
        variant="body2"
        sx={{ color: "#344767", fontWeight: "500", fontSize: "0.95rem" }}
      >
        {value}
      </MDTypography>
    </MDBox>
  </MDBox>
);

// Helper component for stat cards
const StatCard = ({ title, value, color }) => (
  <MDBox
    sx={{
      background: color,
      borderRadius: "12px",
      padding: "20px",
      textAlign: "center",
      color: "white",
      boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
    }}
  >
    <MDTypography
      variant="caption"
      sx={{ color: "rgba(255,255,255,0.8)", fontSize: "0.75rem" }}
    >
      {title}
    </MDTypography>
    <MDTypography
      variant="h4"
      sx={{ color: "white", fontWeight: "bold", marginTop: "5px" }}
    >
      {value}
    </MDTypography>
  </MDBox>
);

export default Welcome;
